// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__3wj4t","titleBox":"style_titleBox__29GKr","title":"style_title__3onlm","slide":"style_slide__X3KDG"};